export default {
  greeting: 'नमस्ते यह होम पेज है',
  intro: 'सरलवेब में आपका स्वागत है, हम एक अत्याधुनिक तकनीकी कंपनी हैं जो सीधी सेवाएं प्रदान करने के लिए समर्पित है'
}
